import { render, staticRenderFns } from "./HealthCheck.vue?vue&type=template&id=d553187a&"
import script from "./HealthCheck.vue?vue&type=script&lang=js&"
export * from "./HealthCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports